import {
    UPDATE_UI_DATA
} from './Types';


import {ILookupReducerState, ILookupAction} from "./lookupsTypes";

const defaultState = {
    uiData: {
        facetChoices: [],
        lookups: {},
        patternChoices: {},
        propertyTypes: {},
        unitTypes: {}
    }
};

export default function reducer (state: ILookupReducerState = defaultState, action:ILookupAction) {
    switch (action.type) {
        case UPDATE_UI_DATA:
            return {
                ...state,
                uiData: action.uiData
            };
        default:
            return state;
    }
}